<template>
  <div v-html="svg" v-once></div>
</template>

<script>
export default {
  props: {
    icon: {
      default: '',
      type: String
    },
    unwrap: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    svg() {
      return require(`!!html-loader!@/assets/icons/${this.icon}.svg`)
    }
  },
  mounted() {
    if (this.unwrap) {
      this.$el.firstChild.classList.add(`icon-${this.icon}`)
      this.$el.firstChild.classList.add('icon')
      this.$el.outerHTML = this.$el.innerHTML
    } else {
      this.$el.classList.add(`icon-${this.icon}`)
      this.$el.classList.add('icon')
    }
  }
}
</script>
